import React from "react";
import { cn } from "./utils";
import { typography } from "./tokens";

export function DotBadge({ children, bg, text, border, dot, className, style }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border",
        bg, text, border,
        className
      )}
      style={{ ...typography.badge, ...style }}
    >
      {dot && <span className={cn("w-1.5 h-1.5 rounded-full", dot)} />}
      {children}
    </span>
  );
}
